import { render, staticRenderFns } from "./Grievance.vue?vue&type=template&id=ba45814c&scoped=true&"
import script from "./Grievance.vue?vue&type=script&lang=js&"
export * from "./Grievance.vue?vue&type=script&lang=js&"
import style0 from "./Grievance.vue?vue&type=style&index=0&id=ba45814c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba45814c",
  null
  
)

export default component.exports